import fromChannels from "../data/fromChannels"

const getChannelName = (channel) => {
    if(channel === fromChannels.SDB) return 'Quầy'
    return channel
}

export default getChannelName